import AppInput from '@nxsys/components/AppInputSearch';
import AppMenuFilter from '@nxsys/components/AppMenuFilter';
import FilterModal from './FilterModal';
import { useCallback, useState } from 'react';
import { AppState } from '@nxsys/store';
import { useSelector } from 'react-redux';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { GetRPNListParams } from '@nxsys/store/slices/rpn/types';
import { debounce } from 'lodash';

type ActionsHeaderProps = {
  onFilter: (params: GetRPNListParams) => void;
};

export const ActionsHeader = ({
  onFilter,
}: ActionsHeaderProps) => {
  const { messages } = useTypedIntl();

  const { rpnList: { queryParams } } = useSelector(
    (state: AppState) => state.rpnStore,
  );

  const [openFilter, setOpenFilter] = useState(false);

  const [searchValue, setSearchValue] = useState('');

  const toggleFilter = () => {
    setOpenFilter(!openFilter);
  }

  const debouncedFetchData = useCallback(
    debounce((search: string) => {
      onFilter({
        ...queryParams,
        page: 0,
        search,
      });
    }, 500),
    [queryParams],
  );


  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchValue(value);
    debouncedFetchData(value);
  };
  
  return (
    <div className="flex items-center gap-2 w-full">
      <AppInput value={searchValue} onChange={handleSearchChange} />
      <AppMenuFilter options={[]} onChange={() => {}} onClick={toggleFilter} />
      <FilterModal
        isOpen={openFilter}
        toggle={toggleFilter}
        title={messages['common.filter']}
        onFilter={onFilter}
      />
    </div>
  );
};
